module.exports = __webpack_public_path__ + "img/vi.ebaa3b94.png";